import { css } from '@emotion/react'

import Oswald from './Oswald.woff'
import Oswald2 from './Oswald.woff2'

export default css`
  @font-face {
    font-family: 'Oswald';
    src: local('Oswald'), local('Oswald'), url(${Oswald}) format('woff'),
      url(${Oswald2}) format('woff2');
    font-weight: 300;
    font-style: normal;
  }
`
